<template>
  <div>
    <Header />

    <!-- Start Categories Destacadas Area -->
    <section class="categories-destacadas section">
      <div class="container">

        <div class="row">
          <!-- Primera Categoría -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-category-card">
              <div class="category-image">
                <img src="@/assets/imgs/goma.png" alt="Imagen de categoría 1" class="category-image-size" />
              </div>
              <div class="category-info text-center">
                <a href="/productos?q=goma" class="btn btn-primary category-btn w-100">Ver Más</a>
              </div>
            </div>
          </div>
          <!-- Segunda Categoría -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-category-card">
              <div class="category-image">
                <img src="@/assets/imgs/casco.png" alt="Imagen de categoría 2" class="category-image-size" />
              </div>
              <div class="category-info text-center">
                <a href="/productos?q=casco" class="btn btn-primary category-btn w-100">Ver Más</a>
              </div>
            </div>
          </div>
          <!-- Tercera Categoría -->
          <div class="col-lg-4 col-md-6 col-12">
            <div class="single-category-card">
              <div class="category-image">
                <img src="@/assets/imgs/guantes.png" alt="Imagen de categoría 3" class="category-image-size" />
              </div>
              <div class="category-info text-center">
                <a href="/productos?q=guantes" class="btn btn-primary category-btn w-100">Ver Más</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Categories Destacadas Area -->

    <!-- Start Trending Product Area -->
    <section class="trending-product section">
      <div class="container">
        <div class="d-flex justify-content-between align-items-center">
          <h2 class="section-title">Productos Destacados</h2>
          <button class="btn btn-mas text-primary" @click="goToMasProductos">
            Ver más
          </button>
        </div>
        <div class="row">
          <div v-if="isLoading" class="loading-overlay">
            <div class="spinner"></div>
          </div>

          <div class="row five-cols">
            <div class="col custom-col" v-for="producto in productos" :key="producto.id">
              <div class="single-product" @click="verDetallesProducto(producto.id)">
                <div class="product-image">
                  <!-- Controles del carrito -->
                  <div class="cart-controls" @click.stop>
                    <template v-if="isProductInCart(producto.id)">
                      <!-- <div class="quantity-controls">
                        <button @click.stop="decrementQuantity(getCartItemId(producto.id))" :disabled="isProcessing"
                          class="quantity-btn">
                          <i class="lni lni-minus"></i>
                        </button>
                        <span class="quantity">{{ getCartQuantity(producto.id) }}</span>
                        <button @click.stop="incrementQuantity(getCartItemId(producto.id))" :disabled="isProcessing"
                          class="quantity-btn">
                          <i class="lni lni-plus"></i>
                        </button>
                      </div> -->
                      <button v-if="isProductInCart(producto.id)" class="cart-button added" disabled
                          title="Agregado al carrito">
                          <div class="icon-wrapper">
                            <i class="lni lni-cart"></i>
                            <i class="lni lni-checkmark-circle check-icon"></i>
                          </div>
                        </button>
                    </template>
                    <template v-else>
                      <button @click.stop="agregarAlCarrito(producto.id)" class="cart-button"
                        :disabled="isProcessing || !isLoggedIn">
                        <i class="lni lni-cart"></i>
                      </button>
                    </template>
                  </div>
                  <img :src="getImagenPortada(producto.imagenes)" alt="#" class="product-image-size" />
                  <div v-if="animationProductId === producto.id" class="product-added-overlay">
                    <div class="overlay-content">
                      <i class="lni lni-checkmark"></i>
                      <span>Producto agregado</span>
                    </div>
                  </div>

                  <!-- Botón Agregar al Carrito -->
                  <!-- <div class="button">
                  <button @click="verDetallesProducto(producto.id)" class="btn btn-outline-primary w-100">
                    <i class="lni lni-angle-double-right"></i> Ver
                  </button>
                </div> -->
                </div>
                <div class="product-info">
                  <!-- <span class="category">{{ toTitleCase(producto.repuesto.nombre) }}</span> -->
                  <h4 class="title">
                    <a @click="verDetallesProducto(producto.id)">{{ toTitleCase(producto.repuesto.nombre) }}</a>
                  </h4>
                  <p class="card-text text-secondary small mb-2" style="font-size: 1.1em">
                    <!-- {{ producto.marca.nombre }} - {{ producto.modelo.nombre }} -->
                  </p>
                  <div class="price" :class="{ blurred: !isLoggedIn }">
                    <span>{{ formatCurrency(producto.precioVenta) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Trending Product Area -->

    <!-- Start Product by Categories Area -->
    <section class="product-by-categories section">
      <div class="container">
        <h2 class="section-title">Mas productos</h2>
        <div class="row">
          <div class="col-12">
            <div class="category-filter">
              <ul class="category-list d-flex flex-wrap">
                <li v-for="item in repuestos.slice(0, 10)" :key="item.repuestoID"
                  @click="filterByCategory(item.repuestoID)" class="category-item" :class="{
                    'selected-category': item.repuestoID === selectedCategory
                  }">
                  <button class="btn btn-outline-primary">
                    {{ item.nombre }}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row five-cols">
          <div class="col custom-col" v-for="producto in filteredProductos.slice(0, 8)" :key="producto.id">
            <div class="single-product" @click="verDetallesProducto(producto.id)">
              <div class="product-image">
                <!-- Controles del carrito -->
                <div class="cart-controls" @click.stop>
                  <template v-if="isProductInCart(producto.id)">
                    <!-- <div class="quantity-controls">
                      <button @click.stop="decrementQuantity(getCartItemId(producto.id))" :disabled="isProcessing"
                        class="quantity-btn">
                        <i class="lni lni-minus"></i>
                      </button>
                      <span class="quantity">{{ getCartQuantity(producto.id) }}</span>
                      <button @click.stop="incrementQuantity(getCartItemId(producto.id))" :disabled="isProcessing"
                        class="quantity-btn">
                        <i class="lni lni-plus"></i>
                      </button>
                    </div> -->
                      <button v-if="isProductInCart(producto.id)" class="cart-button added" disabled
                          title="Agregado al carrito">
                          <div class="icon-wrapper">
                            <i class="lni lni-cart"></i>
                            <i class="lni lni-checkmark-circle check-icon"></i>
                          </div>
                        </button>
                  </template>
                  <template v-else>
                    <button @click.stop="agregarAlCarrito(producto.id)" class="cart-button"
                      :disabled="isProcessing || !isLoggedIn">
                      <i class="lni lni-cart"></i>
                    </button>
                  </template>
                </div>
                <img :src="getImagenPortada(producto.imagenes)" alt="#" class="product-image-size" />
                <div v-if="animationProductId === producto.id" class="product-added-overlay">
                  <div class="overlay-content">
                    <i class="lni lni-checkmark"></i>
                    <span>Producto agregado</span>
                  </div>
                </div>
                <!-- <div class="button">
                  <button @click="verDetallesProducto(producto.id)" class="btn btn-outline-primary w-100">
                    <i class="lni lni-angle-double-right"></i> Ver
                  </button>
                </div> -->
              </div>
              <div class="product-info">
                <!-- <span class="category">{{ toTitleCase(producto.repuesto.nombre) }}</span> -->
                <h4 class="title">
                  <a @click="verDetallesProducto(producto.id)">{{ toTitleCase(producto.repuesto.nombre) }}</a>
                </h4>
                <p class="card-text text-secondary small mb-2" style="font-size: 1.1em">
                  <!-- {{ producto.marca.nombre }} - {{ producto.modelo.nombre }} -->
                </p>
                <div class="price" :class="{ blurred: !isLoggedIn }">
                  <span>{{ formatCurrency(producto.precioVenta) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Product by Categories Area -->

    <a href="#" class="scroll-top">
      <i class="lni lni-chevron-up"></i>
    </a>
  </div>
</template>


<script>
import Header from "@/components/Header.vue";
import Swal from "sweetalert2";
import { ProductoService } from "@/services/ProductoService";
import { RepuestoService } from "@/services/RepuestoService";
import { CarritoService } from "@/services/CarritoService";
import { useRouter } from "vue-router";
import EventBus from "@/EventBus";
import { config } from "@/config"; // Importar la configuración
import { formatCurrency } from "@/utils/formatPrice";

export default {
  name: "HomePage",
  components: {
    Header,
  },
  data() {
    return {
      isLoading: false,
      productos: [], // Estado para almacenar los productos
      cartItems: [],
      filteredProductos: [],
      repuestos: [],
      animationProductId: null,
      selectedCategory: null,
      isProcessing: false,
    };
  },
  async mounted() {
    await this.loadProductos();
    await this.loadRepuestos();

    EventBus.on("cartUpdated", this.handleCartUpdate); // Registra el callback
    if (this.isLoggedIn) {
      await this.fetchCarritoUser(); // Solo carga el carrito si el usuario está logueado
    }
  },
  computed: {
    isInCart() {
      return (productoId) => this.cartItems.some(item => item.productoID === productoId);
    },
    // Verificar si el usuario está logueado comprobando el token
    isLoggedIn() {
      const accessToken = localStorage.getItem("accessToken");
      return accessToken !== null; // Si el token existe, el usuario está logueado
    },
  },
  methods: {
    handleCartUpdate() {
      this.fetchCarritoUser(); // Actualiza el carrito cuando el evento se emite
    },
    formatCurrency,
    toTitleCase(str) {
      if (!str) return ''; // Manejar casos donde str es null o undefined
      return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
      // O una versión más explícita:
      // return str.toLowerCase().split(' ').map(word => {
      //   return word.charAt(0).toUpperCase() + word.slice(1);
      // }).join(' ');
    },
    // Método para cargar productos
    async loadProductos() {
      try {
        this.isLoading = true;

        const response = await ProductoService.getAllProductos();
        if (response && response.datos) {
          this.productos = response.datos;
          this.filteredProductos = response.datos;
        } else {
          this.errorMessage =
            "No se pudieron cargar los productos. Intente nuevamente.";
        }
      } catch (error) {
        console.error("Error al obtener los productos:", error);
        this.errorMessage =
          "Hubo un error al cargar los productos. Intente nuevamente.";
      } finally {
        this.isLoading = false;
      }
    },

    // Método para cargar repuestos (categorías)
    async loadRepuestos() {
      try {
        const response = await RepuestoService.getAllRepuestos();
        if (response) {
          this.repuestos = response;
        } else {
          this.errorMessage =
            "No se pudieron cargar las categorías. Intente nuevamente.";
        }
      } catch (error) {
        console.error("Error al obtener las categorías:", error);
        this.errorMessage =
          "Hubo un error al cargar las categorías. Intente nuevamente.";
      }
    },

    // Método para filtrar productos por categoría
    filterByCategory(repuestoID) {
      // Actualiza la categoría seleccionada
      this.selectedCategory = repuestoID;

      // Filtra los productos basados en el repuestoID
      if (repuestoID) {
        this.filteredProductos = this.productos.filter(
          (producto) => producto.repuestoID === repuestoID
        );
      } else {
        this.filteredProductos = this.productos;
      }
    },
    verDetallesProducto(id) {
      // Redirigir a la página de detalles pasando el `id` como parámetro
      this.$router.push({ name: "ProductoDetalle", params: { id } });
    },
    getImagenPortada(imagenes) {
      // Buscar la imagen que tenga portada true
      const portada = imagenes.find((imagen) => imagen.portada);
      // Si existe una imagen de portada, retornar su URL con la base de config, sino, retornar una imagen por defecto
      if (!portada) return require("@/assets/paquete.png");
      return portada.imagen.startsWith('http') ? portada.imagen : `${config.API_URL}${portada.imagen}`;
    },
    isValidToken() {
      const token = localStorage.getItem("accessToken");
      if (!token) return false;
      const parts = token.split(".");
      return parts.length === 3;
    },
    async agregarAlCarrito(productoId) {
      let accessToken = localStorage.getItem("accessToken");

      if (!this.isValidToken()) {
        localStorage.removeItem("accessToken");
        accessToken = null;
      }

      if (!accessToken) {
        Swal.fire({
          title: "Necesitas iniciar sesión",
          text: "Para agregar productos al carrito, primero debes iniciar sesión.",
          icon: "warning",
          confirmButtonText: "Iniciar sesión",
          customClass: {
            confirmButton: "swal-button--confirm-custom",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirige al usuario a la página de inicio de sesión si confirma
            this.$router.push("/login");
          }
        });
        return;
      }
      // Verifica si ya se está procesando otra solicitud
      if (this.isProcessing) return;

      try {
        this.isProcessing = true; // Inicia el procesamiento

        const response = await CarritoService.addDetalle({
          productoID: productoId,
          cantidad: 1,
        });

        if (response.exito) {
          // Activa la animación para el producto actual
          this.animationProductId = productoId;

          // Después de 2 segundos, ocultar el overlay y mostrar el botón nuevamente
          setTimeout(() => {
            this.animationProductId = null;
            this.isProcessing = false; // Finaliza el procesamiento
          }, 1000); // Duración de la animación

          EventBus.emit("cartUpdated");
        } else {
          this.isProcessing = false; // Finaliza el procesamiento en caso de error
          Swal.fire({
            title: "Error",
            text: `Error: ${response.errores}`,
            icon: "error",
            customClass: {
              confirmButton: "swal-button--confirm-custom",
            },
          });
        }
      } catch (error) {
        this.isProcessing = false; // Finaliza el procesamiento en caso de excepción
        console.error("Error al agregar el producto al carrito:", error);
        Swal.fire({
          title: "Error",
          text: "Error al agregar el producto al carrito",
          icon: "error",
          customClass: {
            confirmButton: "swal-button--confirm-custom",
          },
        });
      }
    },

    goToMasProductos() {
      this.$router.push("/productos");
    },

    handleCartUpdate() {
      this.fetchCarritoUser(); // Actualiza el carrito cuando el evento se emite
    },

    isProductInCart(productoId) {
      const exists = this.cartItems.some(item => item.productoID === productoId);
      return exists;
    },


    getCartItemId(productoId) {
      const item = this.cartItems.find(item => item.productoID === productoId);
      return item ? item.detalleCarritoID : null;
    },

    getCartQuantity(productoId) {
      const item = this.cartItems.find(item => item.productoID === productoId);
      return item ? item.cantidad : 0;
    },

    // Función para incrementar la cantidad de un ítem en el carrito
    async incrementQuantity(itemID) {
      const item = this.cartItems.find((i) => i.detalleCarritoID === itemID);
      if (item) {
        const newQuantity = item.cantidad + 1;
        try {
          const result = await CarritoService.updateDetalle(itemID, newQuantity);

          // Confirmar que la actualización fue exitosa antes de actualizar la UI
          if (result) {
            item.cantidad = newQuantity;
            this.fetchCarritoUser();
            EventBus.emit("cartUpdated");
          } else {
            console.error("Error al confirmar la actualización en el backend.");
          }
        } catch (error) {
          console.error("Error al actualizar la cantidad:", error);
          // Revertir el incremento en caso de error
          item.cantidad--;
        }
      }
    },

    // Función para decrementar la cantidad de un ítem en el carrito
    async decrementQuantity(itemID) {
      const item = this.cartItems.find((i) => i.detalleCarritoID === itemID);
      if (!item) return;

      if (item.cantidad === 1) {
        try {
          await this.removeItem(itemID);
          await this.fetchCarritoUser(); // Asegurar que se actualiza la UI
          EventBus.emit("cartUpdated");
        } catch (error) {
          console.error("Error al eliminar el producto:", error);
        }
      } else {
        try {
          const result = await CarritoService.updateDetalle(itemID, item.cantidad - 1);
          if (result) {
            item.cantidad--;
            await this.fetchCarritoUser();
          } else {
            console.error("Error al confirmar la actualización en el backend.");
          }
        } catch (error) {
          console.error("Error al actualizar la cantidad:", error);
        }
      }
    },



    // Función para actualizar la cantidad de un ítem en el carrito
    async updateQuantity(item) {
      try {
        const result = await CarritoService.updateDetalle(item.detalleCarritoID, item.cantidad);

        // Confirmar que la actualización fue exitosa
        if (result) {
          fetchCarritoUser();
          EventBus.emit("cartUpdated");
        }
      } catch (error) {
        console.error("Error al actualizar la cantidad:", error);
      }
    },

    async fetchCarritoUser() {
      try {
        const datos = await CarritoService.getCarritoUser(); // Llama al servicio

        // Verifica si 'datos' es nulo antes de acceder a 'detallesCarrito'
        if (!datos || !datos.detallesCarrito) {
          this.cartItems = []; // Inicializa con un carrito vacío en la UI
          return;
        }

        // Asigna los detalles del carrito si están disponibles
        this.cartItems = datos.detallesCarrito;
      } catch (error) {
        Swal.fire({
          title: "Error",
          text: error.message || "Error al obtener el carrito",
          icon: "error",
        });
      }
    },

    async removeItem(detalleCarritoID) {
      try {
        const response = await CarritoService.deleteDetalle(detalleCarritoID);

        console.log(response);
        // Verificar que la eliminación fue exitosa antes de actualizar el estado
        if (response) {
          this.cartItems = this.cartItems?.filter(
            (item) => item.detalleCarritoID !== detalleCarritoID
          ) || [];

          this.totalAmount = this.cartItems.reduce(
            (acc, item) => acc + (item.producto?.precioVenta ?? 0) * item.cantidad,
            0
          );
          EventBus.emit("cartUpdated");
        }
      } catch (error) {
        console.error("Error al eliminar ítem:", error);

        Swal.fire({
          title: "Error",
          text: "No se pudo eliminar el ítem.",
          icon: "error",
          customClass: {
            confirmButton: "swal-button--confirm-custom",
          },
        });
      }
    }

  },
};
</script>

<style scoped>
.product-image-size {
  width: 100%;
  height: 200px;
  object-fit: cover;
  position: relative;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.single-product {
  background-color: #fff;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  min-width: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}

.single-product:hover {
  transform: translateY(-10px);
}

/* Overlay de confirmación */
.product-added-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  /* Fondo oscuro semitransparente */
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
  z-index: 10;
  animation: fadeInOut 1s ease-in-out;
}

.overlay-content {
  text-align: center;
}

.overlay-content i {
  font-size: 40px;
  color: #4caf50;
  /* Color del icono de confirmación */
  display: block;
  margin-bottom: 10px;
  animation: bounce 1s;
  /* Animación de rebote */
}

.overlay-content span {
  display: block;
  font-size: 16px;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

@keyframes bounce {

  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-30px);
  }

  60% {
    transform: translateY(-15px);
  }
}

.loading-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  font-size: 18px;
  color: #007bff;
}

.spinner {
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  /* Color de la bola */
  border-radius: 50%;
  width: 60px;
  /* Tamaño de la bola */
  height: 60px;
  /* Tamaño de la bola */
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.btn {
  position: relative;
  overflow: hidden;
  background-color: #007bff;
  /* Color de fondo azul para el botón */
  color: #fff;
  font-weight: bold;
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  transition: background-color 0.3s ease-in-out;
}

.btn:hover {
  background-color: #0056b3;
  /* Cambio de color al pasar el ratón */
}

.btn:disabled {
  background-color: #cccccc;
  /* Cambio de color cuando está deshabilitado */
  cursor: not-allowed;
}

.category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-left: 0;
  list-style: none;
}

.category-item {
  margin: 5px;
}


.selected-category button {
  background-color: #82b3e7;
  /* Asegúrate de aplicar el color de fondo también al botón */
  color: white;
  border-color: #000000;
  border-radius: 5px;
}

.selected-category button:hover {
  background-color: #0056b3;
  /* Color al pasar el mouse cuando está seleccionado */
}

/* Títulos de secciones */
.section-title {
  font-size: 2em;
  font-weight: 600;
  text-align: center;
  color: #007bff;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
  flex-grow: 1;
}

.section-title::after {
  content: '';
  width: 50px;
  height: 3px;
  background-color: #007bff;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.btn-mas {
  border-color: #007bff;
  color: #fff !important;
}

.card {
  transition: transform 0.3s ease-in-out;
}

.card:hover {
  transform: translateY(-10px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.category-title {
  font-size: 1.5rem;
}

.card-text {
  font-size: 0.9rem;
  color: #6c757d;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
  font-weight: bold;
  text-transform: uppercase;
}

.btn-primary:hover {
  background-color: #0056b3;
  border-color: #0056b3;
}

.btn-view-product {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 18px;
  font-size: 1.6rem;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(135deg, #007bff, #0056b3);
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 123, 255, 0.3);
  transition: all 0.3s ease-in-out;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.btn-view-product::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 300%;
  height: 300%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 10%, transparent 70%);
  transition: all 0.5s ease;
  transform: translate(-50%, -50%) scale(0);
  opacity: 0;
}

.btn-view-product:hover::before {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
}

.btn-view-product:hover {
  background: linear-gradient(135deg, #0056b3, #004095);
  box-shadow: 0 6px 14px rgba(0, 123, 255, 0.5);
}

.btn-view-product:active {
  transform: scale(0.95);
}


.cart-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  z-index: 2;
}

.cart-button:hover {
  transform: scale(1.1);
  background-color: #3e6af7;
  color: white;
}

.cart-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity-controls {
  display: flex;
  gap: 5px;
  background-color: white;
  border-radius: 20px;
  padding: 5px;
  position: absolute;
  top: 10px;
  right: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  z-index: 2;
}

.quantity-btn {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.quantity {
  font-size: 16px;
  font-weight: bold;
  color: black;
}

.cart-controls {
  cursor: default;
}
</style>
